export function customService(number) {
  const scriptStr = number.custom_script;
      const srcRegex = /<script\s+[^>]*src=["']([^"'\r\n]*)["']/i;
      const srcMatch = scriptStr.match(srcRegex);
      const src = srcMatch ? srcMatch[1].replace(/[\r\n]/g, "") : null;

      const contentRegex = /<script[^>]*>([\s\S]*?)<\/script>/i;
      const contentMatch = scriptStr.match(contentRegex);
      const scriptContent = contentMatch
        ? contentMatch[1].replace(/[\r\n]/g, "")
        : null;
      
      const script = document.createElement("script");
      script.id = 'dynamic-script'
      if(src){
        script.src = src;
        script.onload = () => scriptContent;
      } else {
        script.innerHTML = scriptContent
      }
      document.body.appendChild(script);
}
